// ---------------------------------------------------------------
// firebase.js — Inicialización central de Firebase
// Exporta `auth` (Authentication) y `db` (Firestore) para toda la app.
// ---------------------------------------------------------------
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import {
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager,
} from "firebase/firestore";

export const firebaseConfig = {
  apiKey: "AIzaSyC_BeshEWxMbfud9KD_Q0P_qyim8TUs5D0",
  authDomain: "calendariofarmaciabuendia.firebaseapp.com",
  projectId: "calendariofarmaciabuendia",
  storageBucket: "calendariofarmaciabuendia.firebasestorage.app",
  messagingSenderId: "648786145584",
  appId: "1:648786145584:web:4598ddea1f328044c118f5",
  measurementId: "G-Z5HGPSVED0",
};

const app = initializeApp(firebaseConfig);

// Servicios que usa la aplicación
export const auth = getAuth(app);

// Firestore con detección automática de long-polling: si la red del
// usuario (proxy, VPN, antivirus o WiFi que degrada QUIC/HTTP3) tira
// abajo el canal en tiempo real —los errores ERR_QUIC_PROTOCOL_ERROR
// / WebChannel 'Listen' transport errored—, el SDK cambia solo a
// HTTP normal (long-polling), mucho más tolerante. Además se activa
// una caché local persistente para que la app siga respondiendo si
// la conexión se cae un momento.
export const db = initializeFirestore(app, {
  experimentalAutoDetectLongPolling: true,
  localCache: persistentLocalCache({
    tabManager: persistentMultipleTabManager(),
  }),
});

export default app;
